module.exports = __webpack_public_path__ + "static/img/img-4-5.ff3b024.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-5.png
// module id = /nYP
// module chunks = 0